class BeraraBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('.berara-compare__range');
    if (!this.range) return;
    this.update = () => this.style.setProperty('--split', `${this.range.value}%`);
    this.range.addEventListener('input', this.update);
    this.update();
  }

  disconnectedCallback() {
    if (this.range && this.update) this.range.removeEventListener('input', this.update);
  }
}

if (!customElements.get('berara-before-after')) {
  customElements.define('berara-before-after', BeraraBeforeAfter);
}
